import gql from 'graphql-tag';

export const GET_CITIES = gql`
  query Cities($provincesID: [ID!]!) {
    cityByProvinceId(provincesId: $provincesID) {
      id
      name
      provinceId
    }
  }
`;

export const GET_ALL_CITIES = gql`
  query AllCities {
    cities {
      id
      name
    }
  }
`;
